import React, {Component, Fragment} from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from "./Styles.module.css";
import Checkbox from '@mui/material/Checkbox';
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import _ from "lodash";
import {MessagesRowV2} from "./MessagesRowV2";
import EditMessageModalV2 from "./EditMessageModalV2";

class MessagesTableV2 extends Component {
    constructor(props){
        super(props);

        this.state = {
            handleStatus: 'LIVE',
            platform: 'teams-only',
            time: Date.now(),
            showModal: false,
            message: '',
            checkedItems: [],
            anchorElement: null,
            showSelectAllCheckbox: false,
            checkboxMessages: [],
        };

        this.ITEM_HEIGHT = 48;
    }

    componentDidMount() {
        const {handleStatus, platform } = this.props;
        this.setState ({
            handleStatus,
            platform
        });

        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    /**
     * Identifies the clicked item and opens the popup menu for the three dots
     * @param event
     */
    handleClick = event => {
        this.setState({anchorElement: event.currentTarget});
    };

    /**
     * Responsible for closing the popup menu
     */
    handleClose = () => {
        this.setState({anchorElement: null});
    };

    closeModalHandler = () => {
        this.setState({ showModal: false });
    };

    showModalHandle = (event, message) => {
        event.preventDefault();
        this.setState({showModal: true, message: message})
    };

    /**
     * Determine if all items are checked
     * @param allItems
     * @param selectedItems
     * @returns {boolean}
     */
    isAllChecked = (allItems, selectedItems) => {
        allItems = allItems || {};
        selectedItems = selectedItems || [];

        return selectedItems.length !== 0 && selectedItems.length === allItems.length;
    };

    /**
     * Select all the items from the checkbox list
     * @param arg
     * @returns {Function}
     */
    selectAll = (arg) => (event) => {
        let allValues = [];
        let { checkedItems } = this.state;

        checkedItems.length = 0;

        const target = event.target;
        if(target.checked){
            arg.map(index => {
                allValues.push(String(index));
                return {allValues}
            });
        }

        this.setState({ checkedItems: allValues });
    };

    /**
     * Select an item from the checkbox list
     * @param event
     */
    selectItem = (event) => {
        const target = event.target;
        const value = _.get(target, 'value');

        let { checkedItems } = this.state;

        if(target.checked) checkedItems.push(value);
        else checkedItems.splice(checkedItems.indexOf(value), 1);

        this.setState({ checkedItems });
    };

    showSelectAll = (value) => {
        this.setState({showSelectAllCheckbox: value});
    };

    getCheckboxMessages = (messageId) => {
        const {checkboxMessages} = this.state;
        checkboxMessages.push(messageId);
        this.setState({ checkboxMessages });
    };
    render() {
        const  { platform, handleStatus, time, checkedItems, anchorElement, showSelectAllCheckbox,checkboxMessages } = this.state;
        const open = Boolean(anchorElement);
        const {
            messages, classes, updateMessageFromSource, blacklist,
            skipMessage, escalateMessage, deleteMessageFromSource, undoMessage,
            likeMessageFromSource, resendForResponseGenList, sendMessageForResponseGen,
            organizations, actionMessage
        } = this.props;

        const isMessageActioned = messages.actioned ? messages.actioned : "";
        let editMessageModal;
        let isAllChecked = this.isAllChecked(checkboxMessages, checkedItems);

        if (this.state.showModal){
            editMessageModal = <EditMessageModalV2
                buttonText="UPDATE"
                onHide={this.closeModalHandler}
                show={this.state.showModal}
                headerText="Update Message From source"
                message={this.state.message}
                updateMessageFromSource={updateMessageFromSource}
                platform={platform}
                closeModalHandler={this.closeModalHandler}
            />
        }

        return(
            <div>
                {editMessageModal}
                <TableContainer className={styles.tableContainer}>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow className={styles.tableRow}>
                                <TableCell align="left" className={styles.tableCell} sx={{ width: '150px', minWidth: '150px' }}>
                                    <span className={styles.typography15}>Organization</span>
                                </TableCell>
                                <TableCell className={styles.tableCell}  sx={{ width: '70px', maxWidth: '80px' }}>
                                    <span className={styles.typography15}>Status</span>
                                </TableCell>
                                <TableCell className={styles.tableCell} sx={{ width: '80px' }}>
                                    <span className={styles.typography15}>Direction</span>
                                </TableCell>
                                <TableCell className={styles.tableCell} sx={{ flexGrow: 1,maxWidth: '250px' }}>
                                    <span className={styles.typography15}>Message</span>
                                </TableCell>
                                <TableCell className={styles.tableCell} sx={{ width: '100px' }}>
                                    <span className={styles.typography15}>Date Imported</span>
                                </TableCell>
                                <TableCell className={styles.tableCell}  sx={{ width: '100px' }}>
                                    <span className={styles.typography15}>Date Created</span>
                                </TableCell>
                                <TableCell className={styles.tableCell} sx={{width: "30px", minWidth: '30px'}}></TableCell>
                                <TableCell className={styles.tableCell} sx={{width: "30px", minWidth: '30px'}}>
                                    {showSelectAllCheckbox &&
                                        <Checkbox
                                            onChange={this.selectAll(checkboxMessages)}
                                            checked={isAllChecked}
                                            sx={{
                                                color: "#c8c8c8",
                                                padding: "7px",
                                                '&.Mui-checked': {
                                                    color: "#003300",
                                                },
                                            }}
                                        />
                                    }
                                </TableCell>
                                <TableCell className={styles.tableCell} sx={{width: "20px", minWidth: '20px'}}>
                                    {checkedItems.length > 0 &&
                                    <Fragment>
                                        <IconButton
                                            aria-label="More"
                                            aria-owns={open ? 'long-menu' : undefined}
                                            aria-haspopup="true"
                                            onClick={this.handleClick}
                                            disableRipple={true}
                                            sx={{
                                                padding: "1px 0",
                                                fontSize: 2,
                                                borderRadius: '3px',
                                                width: '32px',
                                                border: '1px solid #a8a8a8'
                                            }}
                                        >
                                            <MoreHorizIcon sx={{color: '#808080'}} size="small"/>
                                        </IconButton>

                                        <Menu
                                            id="long-menu"
                                            anchorEl={anchorElement}
                                            open={open}
                                            onClose={this.handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                        >
                                            <MenuItem onClick={this.handleClose} sx={{height: '0px', outline: 'none', padding: '16px 0'}}>
                                                <button type="button" className={`btn ${styles["btnStyle"]}`} onClick={() => escalateMessage(this.state.checkedItems)}>
                                                    Escalate
                                                </button>
                                            </MenuItem>
                                            <MenuItem onClick={this.handleClose} sx={{height: '10px', outline: 'none', padding: '16px 0'}}>
                                                <button type="button" className={`btn ${styles["btnStyle"]}`} onClick={() => skipMessage(this.state.checkedItems)}>
                                                    No response needed
                                                </button>
                                            </MenuItem>
                                            {!isMessageActioned &&
                                                <MenuItem onClick={this.handleClose}  sx={{height: '10px', outline: 'none', padding: '16px 0'}}>
                                                    <button type="button" className={`btn ${styles["btnStyle"]}`} onClick={() => actionMessage(this.state.checkedItems)}>
                                                        Action
                                                    </button>
                                                </MenuItem>
                                            }
                                        </Menu>
                                    </Fragment>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {_.get(messages, 'length') > 0 && messages.length === 0 &&
                                <TableRow className={styles.tableRow}>
                                    <TableCell colSpan={4}>There are no messages available</TableCell>
                                </TableRow>
                            }
                            {_.get(messages, 'length') > 0 && messages.map(message => {
                                return <MessagesRowV2
                                    updateMessageFromSource={updateMessageFromSource}
                                    handleStatus={handleStatus}
                                    message={message}
                                    classes={classes}
                                    platform={platform}
                                    blacklist={blacklist}
                                    skipMessage={() => skipMessage(message.id)}
                                    escalateMessage={() => escalateMessage(message.id)}
                                    likeMessageFromSource={likeMessageFromSource}
                                    undoMessage={undoMessage}
                                    deleteMessageFromSource={deleteMessageFromSource}
                                    time={time}
                                    key={message.id}
                                    closeModalHandler={this.closeModalHandler}
                                    showModalHandle={this.showModalHandle}
                                    selectItem={this.selectItem}
                                    selectedMessages={checkedItems}
                                    showSelectAll={this.showSelectAll}
                                    getCheckboxMessages={this.getCheckboxMessages}
                                    resendForResponseGenList={resendForResponseGenList}
                                    sendMessageForResponseGen={sendMessageForResponseGen}
                                    organizations={organizations}
                                    actionMessage={() => actionMessage([message.id])}
                                />
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
}

export { MessagesTableV2 }